// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import './style/style.css';
// 引入路由
import router from './router';
Vue.filter("formValidateFun", (value, type) => {
    value = (value + "").replace(/(^\s*)|(\s*$)/g, ""); // 先去除前后空格，排除都是空格的情况
    switch (type) {
      case "number":
        value = value || value === 0 ? Number(value) : "";
        break;
    }
    return value;
  });
// 引入icon
import './assets/icon/iconfont.css'
//
// 富文本组件
import Editor from "@/components/Editor/index.vue"
Vue.component('Editor', Editor)
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.config.productionTip = false;
// 引入状态管理
import store from './vuex/store';
// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from './utils/util'

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})
let whiteList = ['/login','/charts/statistics','/system/userCenter'] //白名单
// 路由拦截器
router.beforeEach((to, from, next) => {
    console.log(to.path,'tofrompath',from.path);
    if (to.matched.length != 0) {
        if (whiteList.indexOf(to.path) !== -1) {
            // 在免登录白名单，直接进入
            next()
          }else{
          console.log(to.meta.requireAuth)
            if (to.meta.requireAuth) { // 判断该路由是否需要登录权限

                let roleRouter =localStorage.getItem("roleRouter")
                // let roleRouter =localStorage.getItem("roleRouter").slice()
                if(!!roleRouter){
                    roleRouter= roleRouter.slice()
                }else{
                    roleRouter= ""
                }
                let isHaveRole = false
                  // || (roleRouter.indexOf(from.path) == 1 && from.path = '/pay/Order')
              const arr = to.path.split("/")
              const cho = '/'+ arr[1]+'/' + arr[2];
                isHaveRole = ( roleRouter.indexOf(to.path) !== -1 || roleRouter.indexOf(cho) !== -1  ) ? true : false
                // if (roleRouter.indexOf(from.path) !== -1 && from.path == '/pay/Order'){
                //   isHaveRole = true
                // }
                // console.log('isHaveRole',isHaveRole);
                if (Boolean(localStorage.getItem("userInfo"))) { // 通过vuex state获取当前的user是否存在
                    if(isHaveRole){
                        next();
                    }
                    else{
                        next({
                            path: from.path, //没有路由权限依旧加载当前页面
                        })
                    }
                } else {
                    next({
                        path: '/login',
                        query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                    })
                }
            } else {
                if (Boolean(localStorage.getItem("userInfo"))) { // 判断是否登录
                    if (to.path != "/" && to.path != "/login") { //判断是否要跳到登录界面
                        next();
                    } else {
                        /**
                         * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页
                         */
                        next({
                            path: '/charts/statistics'
                        })
                    }
                } else {
                    next();
                }
            }
          }

    } else {
      // next();
        next({
            path: '/login',
            query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
    }
})


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})



// WEBPACK FOOTER //
// ./src/main.js